import { Component } from './Component';
import { SessionService } from '../services/SessionService';
import { ApiService } from '../services/ApiService';

/**
 * GDPR Component.
 */
export class GDPR extends Component {
  render(opts) {
    Component.updateTracking({ type_page: 'protection' });
    super.render(opts);
  }

  /**
   * Back event treatment for gdpr components.
   *
   * @returns {Promise} Promise of the component make Requests.
   */
  back() {
    const opt = {
      url: ApiService.apiSchema.gdpr.back.url,
      method: ApiService.apiSchema.gdpr.back.method,
    };

    return Component.makeRequest(opt, true)
      .then(() => SessionService.restartSessionTimer());
  }
}
